module.exports = __webpack_public_path__ + "static/img/line.0931618a.png";